import http from "@/api/http";

export const claimPointApi = (nftId: number) => http.post(`/api/points/claim/${nftId}`);
export const checkClaimApi = (nftId: number) => http.get(`/api/points/claim/check/${nftId}`);
